import React from 'react'

export const SettingsPanelContext = React.createContext({})
